import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { EmployerContext } from '../../Store/EmployerContext'
import { getEmployers, getEmployeeInformation } from '../../API/Analytics/employers'
import WheelColaboradores from './Components/Wheel/WheelColaboradores'
import { MdError } from 'react-icons/md'

import './colaboradores.sass'
import Loading from '../../Components/Loading/Loading'
import { getEmployeesURL } from '../../API/Employee/Employee.js'

const img = 'https://assets.mydna.company/profile-placeholder.png'

const Colaboradores = () => {
	const token = localStorage.getItem('token')
	const { id } = useParams()
	const { store, actions } = useContext(EmployerContext)
	const [loading, setLoading] = useState(false)
	const [employeeEmail, setEmployeeEmail] = useState('')
	const [employeeImages, setEmployeeImages] = useState([])
	const [noPermission, setNoPermission] = useState(false)

	useEffect(() => {
		actions.setEmployerID(id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		const fetchEmployers = async () => {
			setLoading(true)
			const user = JSON.parse(localStorage.getItem('user'))
			const response = await getEmployers(user.id)
			const ids = response.map(employer => employer.id)
			if (!ids.includes(Number(id))) {
				setNoPermission(true)
				setLoading(false)
				return
			}

			const [data] = response.filter(employer => employer.id === Number(id))
			const company = user.id
			const information_response = await getEmployeeInformation(id)
			const employeeImages = await getEmployeesURL(company, token)
			setEmployeeImages(employeeImages)
			setEmployeeEmail(data.email)
			actions.setEmployeer({
				...data,
				information: information_response,
				email: data.email,
			})
			setLoading(false)
		}
		fetchEmployers()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	return (
		<>
			{loading ? (
				<Loading />
			) : noPermission ? (
				<div className='tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[60vh]'>
					<MdError className='tw-text-4xl tw-text-red-600 tw-mb-2' />
					<div className='tw-text-center tw-text-red-600 tw-font-bold tw-text-lg '>No tienes permiso para acceder a esta página.</div>
				</div>
			) : (
				<div className='content-colaboradores'>
					<div className='row'>
						<div className='col'>
							<WheelColaboradores
								currentUserId={id}
								img={employeeImages.find(img => img.mydnaUserEmail === employeeEmail)?.url || 'https://assets.mydna.company/profile-placeholder.png'}
							/>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
export default Colaboradores
